export enum AppVariant {
  PORTAL = 'portal',
  GATEWAY = 'gateway',
  VISION = 'vision',
  ACADEMY = 'academy',
  MODULES = 'modules',
  CONFERENCE = 'conference',
}
